import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  
  // WhatsApp numarası (uluslararası format: ülke kodu + numara, boşluksuz)
  const whatsappNumber = '420774668988';
  const message = 'Merhaba, Çekya eğitim danışmanlığı hakkında bilgi almak istiyorum.';
  
  useEffect(() => {
    // Sayfa yüklendikten 2 saniye sonra butonu göster
    const timer = setTimeout(() => {
      setIsVisible(true);
      // 3 saniye sonra tooltip'i göster
      setTimeout(() => setShowTooltip(true), 1000);
      // 8 saniye sonra tooltip'i gizle
      setTimeout(() => setShowTooltip(false), 8000);
    }, 2000);
    
    return () => clearTimeout(timer);
  }, []);

  const handleWhatsAppClick = () => {
    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  if (!isVisible) return null;

  return (
    <>
      {/* Tooltip */}
      {showTooltip && (
        <div className="fixed bottom-28 right-6 z-50 animate-in slide-in-from-bottom-5 fade-in duration-500">
          <div className="bg-white rounded-lg shadow-2xl p-4 max-w-xs relative">
            <button
              onClick={() => setShowTooltip(false)}
              className="absolute -top-2 -right-2 w-6 h-6 bg-gray-800 text-white rounded-full flex items-center justify-center hover:bg-gray-900 transition-colors"
            >
              <X size={14} />
            </button>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                <MessageCircle className="text-white" size={20} />
              </div>
              <div>
                <p className="font-semibold text-gray-900 mb-1">Merhaba! 👋</p>
                <p className="text-sm text-gray-600">
                  WhatsApp'tan bizimle iletişime geçebilirsiniz. Size yardımcı olmaktan mutluluk duyarız!
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* WhatsApp Button */}
      <button
        onClick={handleWhatsAppClick}
        className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-green-500 text-white rounded-full shadow-2xl hover:bg-green-600 transition-all hover:scale-110 flex items-center justify-center group animate-in zoom-in duration-500"
        aria-label="WhatsApp ile iletişime geç"
      >
        <MessageCircle size={32} className="group-hover:scale-110 transition-transform" />
        
        {/* Pulse animation */}
        <span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-75"></span>
      </button>
    </>
  );
};

export default WhatsAppButton;
